/**
 * Max width of a content container. Starts at the Code.org value so authored
 * layouts match; change it here rather than reaching into the Code.org theme.
 */
export const SECTION_MAX_WIDTH = '1280px';
